module.exports = __webpack_public_path__ + "static/media/a.67323a6c.mp3";